// import React, { useEffect, useState } from "react";
// import { Api } from "../Api/Api";

// const API_BASE = `${Api}buyer`;

// export default function BuyerDetails() {
//   const [companies, setCompanies] = useState([]);
//   const [loadingTable, setLoadingTable] = useState(false);
//   const [loadingForm, setLoadingForm] = useState(false);
//   const [message, setMessage] = useState(null);

//   const [editId, setEditId] = useState(null);
//   const [formData, setFormData] = useState({
//     companyName: "",
//     gstNumber: "",
//     ownerName: "",
//     address: "",
//     contactNumber: "",
//   });

//   // 🔹 Fetch all companies
//   const fetchCompanies = async () => {
//     setLoadingTable(true);
//     setMessage(null);
//     try {
//       const res = await fetch(`${API_BASE}/get.php`);
//       if (!res.ok) throw new Error("Failed to fetch company data");
//       const data = await res.json();
//       setCompanies(data || []);
//       console.log(data);
//     } catch (err) {
//       console.error(err);
//       setMessage("❌ Failed to load company details.");
//     }
//     setLoadingTable(false);
//   };

//   useEffect(() => {
//     fetchCompanies();
//   }, []);

//   // 🔹 Handle form field changes
//   const handleChange = (e) => {
//     setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   // 🔹 Populate form for editing
//   const handleEditClick = (company) => {
//     setEditId(company.id);
//     setFormData({
//       companyName: company.company_name,
//       gstNumber: company.gst_number,
//       ownerName: company.owner_name,
//       address: company.address,
//       contactNumber: company.contact_number,
//     });
//     setMessage(null);
//   };

//   // 🔹 Cancel edit
//   const cancelEdit = () => {
//     setEditId(null);
//     setFormData({
//       companyName: "",
//       gstNumber: "",
//       ownerName: "",
//       address: "",
//       contactNumber: "",
//     });
//     setMessage(null);
//   };

//   // 🔹 Update company details
//   const handleUpdate = async (e) => {
//     e.preventDefault();
//     if (!editId) return;

//     setLoadingForm(true);
//     setMessage(null);

//     try {
//       const res = await fetch(`${API_BASE}/update.php`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ id: editId, ...formData }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message || "Update failed");

//       setMessage("✅ Company updated successfully!");
//       cancelEdit();
//       fetchCompanies();
//     } catch (err) {
//       console.error(err);
//       setMessage(err.message || "❌ Failed to update company.");
//     }

//     setLoadingForm(false);
//   };

//   // 🔹 Delete a company
//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this company?"))
//       return;

//     setLoadingTable(true);
//     setMessage(null);

//     try {
//       const res = await fetch(`${API_BASE}/delete.php`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ id }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message || "Delete failed");

//       setMessage("✅ Company deleted successfully!");
//       fetchCompanies();
//     } catch (err) {
//       console.error(err);
//       setMessage(err.message || "❌ Failed to delete company.");
//     }

//     setLoadingTable(false);
//   };

//   return (
//     <div className="max-w-6xl mx-auto p-4 sm:p-6 bg-white shadow rounded-lg mt-10">
//       <h2 className="text-2xl font-semibold mb-6 text-center">
//         Buyer Company Details
//       </h2>

//       {/* 🔹 Alert messages */}
//       {message && (
//         <div
//           className={`mb-4 p-3 rounded text-center ${
//             message.includes("✅")
//               ? "bg-green-100 text-green-700"
//               : "bg-red-100 text-red-700"
//           }`}
//         >
//           {message}
//         </div>
//       )}

//       {/* 🔹 Edit Form */}
//       {editId && (
//         <form
//           onSubmit={handleUpdate}
//           className="mb-8 space-y-4 border p-4 rounded bg-gray-50"
//         >
//           <h3 className="text-xl font-semibold mb-4 text-center">
//             Edit Company ID: {editId}
//           </h3>

//           {[
//             "companyName",
//             "gstNumber",
//             "ownerName",
//             "address",
//             "contactNumber",
//           ].map((field) => (
//             <div key={field}>
//               <label
//                 className="block mb-1 font-medium capitalize"
//                 htmlFor={field}
//               >
//                 {field.replace(/([A-Z])/g, " $1")}
//               </label>
//               {field === "address" ? (
//                 <textarea
//                   id={field}
//                   name={field}
//                   rows={3}
//                   required
//                   value={formData[field]}
//                   onChange={handleChange}
//                   className="w-full border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-indigo-500"
//                 />
//               ) : (
//                 <input
//                   type={field === "contactNumber" ? "tel" : "text"}
//                   id={field}
//                   name={field}
//                   required
//                   pattern={field === "contactNumber" ? "[0-9]{10}" : undefined}
//                   value={formData[field]}
//                   onChange={handleChange}
//                   className="w-full border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-indigo-500"
//                 />
//               )}
//             </div>
//           ))}

//           <div className="flex gap-3">
//             <button
//               type="submit"
//               disabled={loadingForm}
//               className="flex-1 bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700 transition"
//             >
//               {loadingForm ? "Saving..." : "Update"}
//             </button>
//             <button
//               type="button"
//               onClick={cancelEdit}
//               className="flex-1 bg-gray-400 text-black py-2 rounded hover:bg-gray-500 transition"
//             >
//               Cancel
//             </button>
//           </div>
//         </form>
//       )}

//       {/* 🔹 Table */}
//       <div className="overflow-x-auto">
//         {loadingTable ? (
//           <p className="text-center text-gray-500 py-6">Loading...</p>
//         ) : (
//           <table className="w-full border border-gray-300 min-w-[700px]">
//             <thead className="bg-gray-100">
//               <tr>
//                 {[
//                   "ID",
//                   "Company Name",
//                   "GST Number",
//                   "Owner Name",
//                   "Address",
//                   "Contact Number",
//                   "Actions",
//                 ].map((col) => (
//                   <th
//                     key={col}
//                     className="border border-gray-300 px-4 py-2 text-left whitespace-nowrap"
//                   >
//                     {col}
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody>
//               {companies.length === 0 ? (
//                 <tr>
//                   <td colSpan="7" className="text-center py-6 text-gray-500">
//                     No companies found.
//                   </td>
//                 </tr>
//               ) : (
//                 companies.map((company, index) => (
//                   <tr key={company.id} className="hover:bg-gray-50">
//                     <td className="border border-gray-300 px-4 py-2">
//                       {index + 1}
//                     </td>
//                     <td className="border border-gray-300 px-4 py-2">
//                       {company.company_name}
//                     </td>
//                     <td className="border border-gray-300 px-4 py-2">
//                       {company.gst_number}
//                     </td>
//                     <td className="border border-gray-300 px-4 py-2">
//                       {company.owner_name}
//                     </td>
//                     <td className="border border-gray-300 px-4 py-2">
//                       {company.address}
//                     </td>
//                     <td className="border border-gray-300 px-4 py-2">
//                       {company.contact_number}
//                     </td>

//                     <td className="border border-gray-300 px-4 py-2 text-center">
//                       <div className="flex justify-center space-x-2">
//                         <button
//                           onClick={() => handleEditClick(company)}
//                           className="px-3 py-1 bg-yellow-400 rounded hover:bg-yellow-500"
//                         >
//                           Edit
//                         </button>
//                         <button
//                           onClick={() => handleDelete(company.id)}
//                           className="px-3 py-1 bg-red-500 rounded hover:bg-red-600 text-white"
//                         >
//                           Delete
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         )}
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import { Api } from "../Api/Api";
import Swal from "sweetalert2"; // ✅ import swal

const API_BASE = `${Api}buyer`;

export default function BuyerDetails() {
  const [companies, setCompanies] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);
  const [loadingForm, setLoadingForm] = useState(false);
  const [message, setMessage] = useState(null);

  const [editId, setEditId] = useState(null);
  const [formData, setFormData] = useState({
    companyName: "",
    gstNumber: "",
    ownerName: "",
    address: "",
    contactNumber: "",
  });

  // 🔹 Fetch all companies
  const fetchCompanies = async () => {
    setLoadingTable(true);
    setMessage(null);
    try {
      const res = await fetch(`${API_BASE}/get.php`);
      if (!res.ok) throw new Error("Failed to fetch company data");
      const data = await res.json();
      setCompanies(data || []);
    } catch (err) {
      console.error(err);
      setMessage("❌ Failed to load company details.");
    }
    setLoadingTable(false);
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  // 🔹 Handle form field changes
  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  // 🔹 Populate form for editing
  const handleEditClick = (company) => {
    setEditId(company.id);
    setFormData({
      companyName: company.company_name,
      gstNumber: company.gst_number,
      ownerName: company.owner_name,
      address: company.address,
      contactNumber: company.contact_number,
    });
    setMessage(null);
  };

  // 🔹 Cancel edit
  const cancelEdit = () => {
    setEditId(null);
    setFormData({
      companyName: "",
      gstNumber: "",
      ownerName: "",
      address: "",
      contactNumber: "",
    });
    setMessage(null);
  };

  // 🔹 Update company details
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!editId) return;

    setLoadingForm(true);
    setMessage(null);

    try {
      const res = await fetch(`${API_BASE}/update.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: editId, ...formData }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Update failed");

      Swal.fire("✅ Success!", "Company updated successfully!", "success");
      cancelEdit();
      fetchCompanies();
    } catch (err) {
      console.error(err);
      Swal.fire(
        "❌ Error",
        err.message || "Failed to update company.",
        "error"
      );
    }

    setLoadingForm(false);
  };

  // 🔹 Delete a company
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This company will be permanently deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoadingTable(true);
        try {
          const res = await fetch(`${API_BASE}/delete.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id }),
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.message || "Delete failed");

          Swal.fire("Deleted!", "Company deleted successfully!", "success");
          fetchCompanies();
        } catch (err) {
          console.error(err);
          Swal.fire(
            "❌ Error",
            err.message || "Failed to delete company.",
            "error"
          );
        }
        setLoadingTable(false);
      }
    });
  };

  return (
    <div className="max-w-6xl mx-auto p-4 sm:p-6 bg-white shadow rounded-lg mt-10">
      <h2 className="text-2xl font-semibold mb-6 text-center">
        Buyer Company Details
      </h2>

      {/* 🔹 Edit Form */}
      {editId && (
        <form
          onSubmit={handleUpdate}
          className="mb-8 space-y-4 border p-4 rounded bg-gray-50"
        >
          <h3 className="text-xl font-semibold mb-4 text-center">
            Edit Company ID: {editId}
          </h3>

          {[
            "companyName",
            "gstNumber",
            "ownerName",
            "address",
            "contactNumber",
          ].map((field) => (
            <div key={field}>
              <label
                className="block mb-1 font-medium capitalize"
                htmlFor={field}
              >
                {field.replace(/([A-Z])/g, " $1")}
              </label>
              {field === "address" ? (
                <textarea
                  id={field}
                  name={field}
                  rows={3}
                  required
                  value={formData[field]}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-indigo-500"
                />
              ) : (
                <input
                  type={field === "contactNumber" ? "tel" : "text"}
                  id={field}
                  name={field}
                  required
                  pattern={field === "contactNumber" ? "[0-9]{10}" : undefined}
                  value={formData[field]}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-indigo-500"
                />
              )}
            </div>
          ))}

          <div className="flex gap-3">
            <button
              type="submit"
              disabled={loadingForm}
              className="flex-1 bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700 transition"
            >
              {loadingForm ? "Saving..." : "Update"}
            </button>
            <button
              type="button"
              onClick={cancelEdit}
              className="flex-1 bg-gray-400 text-black py-2 rounded hover:bg-gray-500 transition"
            >
              Cancel
            </button>
          </div>
        </form>
      )}

      {/* 🔹 Table */}
      <div className="overflow-x-auto">
        {loadingTable ? (
          <p className="text-center text-gray-500 py-6">Loading...</p>
        ) : (
          <table className="w-full border border-gray-300 min-w-[700px]">
            <thead className="bg-gray-100">
              <tr>
                {[
                  "ID",
                  "Company Name",
                  "GST Number",
                  "Owner Name",
                  "Address",
                  "Contact Number",
                  "Actions",
                ].map((col) => (
                  <th
                    key={col}
                    className="border border-gray-300 px-4 py-2 text-left whitespace-nowrap"
                  >
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {companies.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center py-6 text-gray-500">
                    No companies found.
                  </td>
                </tr>
              ) : (
                companies.map((company, index) => (
                  <tr key={company.id} className="hover:bg-gray-50">
                    <td className="border border-gray-300 px-4 py-2">
                      {index + 1}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {company.company_name}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {company.gst_number}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {company.owner_name}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {company.address}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      {company.contact_number}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-center">
                      <div className="flex justify-center space-x-2">
                        <button
                          onClick={() => handleEditClick(company)}
                          className="px-3 py-1 bg-yellow-400 rounded hover:bg-yellow-500"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDelete(company.id)}
                          className="px-3 py-1 bg-red-500 rounded hover:bg-red-600 text-white"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
